import { useParams, Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Lock } from "lucide-react";
import SectionRenderer from "@/components/SectionRenderer";
import api from "@/lib/api";

export default function DynamicPage() {
  const { slug } = useParams();
  const { data, isLoading, error } = useQuery({
    queryKey: ["page", slug],
    queryFn: () => api.get(`/pages/${slug}`).then((r) => r.data),
    retry: false,
  });

  if (isLoading) return <div className="grid place-items-center py-40 text-[#4A5D6B]" data-testid="page-loading"><Loader2 className="animate-spin" /></div>;

  if (error) {
    const membersOnly = error?.response?.status === 403;
    return (
      <div className="grid place-items-center py-40 px-6 text-center" data-testid="page-error">
        <div>
          {membersOnly ? <Lock size={36} className="text-[#144F75] mx-auto mb-4" /> : null}
          <h1 className="font-serif text-3xl text-[#1A242B]">{membersOnly ? "Members only" : "Page not found"}</h1>
          <p className="text-[#4A5D6B] mt-2">{membersOnly ? "Please sign in or upgrade your membership to view this page." : "This page doesn't exist or hasn't been published yet."}</p>
          <div className="mt-6 flex gap-3 justify-center">
            {membersOnly && <Link to="/login" className="eyw-btn">Log in</Link>}
            <Link to="/" className="eyw-btn-ghost">Back home</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div data-testid={`dynamic-page-${slug}`}>
      <Seo title={data.seo_title || data.title || ""} description={data.seo_description || ""} path={`/p/${slug}`} />
      {(data.sections || []).map((s, i) => <SectionRenderer key={s.id || i} section={s} />)}
    </div>
  );
}
